/*
  Môdern Match — live image/title refresh (Sep 28, 2026)

  Môdern Match reads products from a prebuilt snapshot (studio-match-index.json).
  When a product's photo or title is changed in Shopify after that snapshot was
  built, the snapshot still points at the old image file, which no longer
  exists — so the card shows a broken image with the old title as its alt text.

  This small add-on fixes that in the browser: if a result image fails to load,
  it fetches the product's current data from Shopify (/products/<handle>.js) and
  swaps in the live image and title. It changes nothing when images load fine.

  The lasting fix is to regenerate studio-match-index.json from the live
  catalog; this keeps customers from seeing broken cards in the meantime.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-modern-match]');
  if (!root) return;

  var pending = {};

  function toHttps(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function sized(url, width) {
    // Shopify CDN: add a width parameter so we don't download full-size photos.
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function refreshCard(card, img) {
    var handle = card.getAttribute('data-mm-handle');
    if (!handle || card.getAttribute('data-mm-refreshed') === '1') return;
    card.setAttribute('data-mm-refreshed', '1');

    if (!pending[handle]) {
      pending[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    pending[handle].then(function (p) {
      if (!p) {
        if (img && img.parentNode) img.parentNode.removeChild(img);
        return;
      }
      var liveImage = toHttps(p.featured_image || (p.images && p.images[0]) || '');
      if (img) {
        if (liveImage) {
          img.src = sized(liveImage, 600);
          img.alt = p.title || img.alt;
        } else if (img.parentNode) {
          img.parentNode.removeChild(img);
        }
      }
      var titleEl = card.querySelector('.gift-result-card__title');
      if (titleEl && p.title) titleEl.textContent = p.title;
      var heart = card.querySelector('[data-wishlist-toggle]');
      if (heart) {
        if (liveImage) heart.setAttribute('data-wishlist-image', liveImage);
        if (p.title) heart.setAttribute('data-wishlist-title', p.title);
      }
    });
  }

  // Image load errors don't bubble, so listen in the capture phase.
  root.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    var card = img.closest('[data-mm-handle]');
    if (card) refreshCard(card, img);
  }, true);
})();
